import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux';
import { setProductOptionsData, productState } from '../store/slices/product'
import { setPaymentOptionsData, paymentState } from '../store/slices/payment'

import { useTranslation } from 'react-i18next';
import { FormContext, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import { Button } from '../components/';

import { getProductDataList } from '../services/product';
import { getPaymentDataList } from '../services/payment';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

/**
* Common HOC for all pages
* 
* @param props
* @param {Object} props.children    - The child component
* @param {string} props.title       - Page title
* @param {Object} props.navigation  - Navigation object
*/
const BasePage = ({ children, title, navigation }) => {
  const { t } = useTranslation('global');
  const dispatch = useDispatch();
  const { productOptions } = useSelector(productState);
  const { paymentOptions } = useSelector(paymentState);
  const [hasApiError, setApiError] = useState(false);

  const history = useHistory();
  const methods = useForm();

  const { REACT_APP_RECAPTCHA_KEY } = process.env;
  const { primary, secondary } = navigation;

  const isObjectEmpty = (object) => Object.keys(object).length === 0;

  const formSubmitHandler = () => {
    primary.onBeforePageChange && primary.onBeforePageChange();
    history.push(primary?.path);
  };

  const goBack = () => {
    secondary.onBeforePageChange && secondary.onBeforePageChange();
    history.push(secondary?.path);
  };

  useEffect(() => {
    hasApiError && history.push('/error')
  }, [hasApiError]);


  useEffect(() => {
    isObjectEmpty(productOptions) && getProductDataList()
    .then((data) => dispatch(setProductOptionsData({ ...data })))
    .catch(() => setApiError(true));

    isObjectEmpty(paymentOptions) && getPaymentDataList()
    .then((data) => dispatch(setPaymentOptionsData({ name: 'methodList', data })))
    .catch(() => setApiError(true));
  }, []);

  return (
    <section className='page'>
      <FormContext {...methods}>
        <form onSubmit={methods.handleSubmit(formSubmitHandler)}>
          <h1 className='page__title'>
            {title}
          </h1>
          <GoogleReCaptchaProvider reCaptchaKey={REACT_APP_RECAPTCHA_KEY}>
            {children}
          </GoogleReCaptchaProvider>
          <div className='page__footer'>
            {
              secondary?.path &&
              <Button
                type='button'
                text={secondary?.text || t('button.secondary')}
                mode='tertiary'
                onClick={goBack}
              />
            }
            {
              primary?.path &&
              <Button
                type='submit'
                text={primary?.text || t('button.primary')}
                mode='primary'
              />
            }
          </div>
        </form>
      </FormContext>
    </section>
  );
}
BasePage.defaultProps = {
  navigation: {}
}
BasePage.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  navigation: PropTypes.object
};
export default BasePage;